import { APP_CONFIG, IAppConfig } from '@adnoc/servicebox';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class SandboxEnvironmentService {
  constructor(
    @Inject(APP_CONFIG) private readonly config: IAppConfig,
  ) {}

  get apiUrl(): string {
    return this.config.oneHubApiUrl;
  }

  get apiUrlPrefix(): string {
    const partsToLeave = -2;
    const apiUrlSplit = this.apiUrl.split('/');

    return apiUrlSplit.slice(partsToLeave).join('/');
  }
}
